// @ts-nocheck
import failPanel from './failPanel';

export { failPanel };
